// extracted by mini-css-extract-plugin
export default {"box":"CustomTooltip_box__aWXZl","title":"CustomTooltip_title__O3zEJ","item":"CustomTooltip_item__0baO2","text":"CustomTooltip_text__7gMnv","name":"CustomTooltip_name__N8CXv"};